
          var __hack_curDefine = window.define;
          window.define = undefined;
        